import { render, staticRenderFns } from "./MergeReportModal.vue?vue&type=template&id=67d6cf86&scoped=true&"
import script from "./MergeReportModal.vue?vue&type=script&lang=js&"
export * from "./MergeReportModal.vue?vue&type=script&lang=js&"
import style0 from "./MergeReportModal.vue?vue&type=style&index=0&id=67d6cf86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d6cf86",
  null
  
)

export default component.exports